import { useState, useEffect, useRef } from "react";
import "./TerrainWeb.css";
import MetiersTicker from "./MetiersTicker";
import logo from './images/logo.png';
import { IoPricetagsOutline } from "react-icons/io5";
import emailjs from "@emailjs/browser";



const NAV_LINKS = [
  { label: "Formules", href: "#formules" },
  { label: "Réalisations", href: "#realisations" },
  { label: "Comment ça marche", href: "#process" },
  { label: "Avis", href: "#avis" },
  { label: "Contact", href: "#contact" },
];

const FORMULES = [
  {
    nom: "Starter",
    prix: "750€",
    type: "une fois",
    tag: null,
    description: "Idéal pour démarrer avec une présence professionnelle en ligne.",
    inclus: [
      "Site vitrine personnalisé jusqu'à 4 pages",
      "Référencement général Google (indexation moteurs de recherche)",
      "Google Business Profile configuré",
      "Hébergement 1 an inclus",
      "Formulaire de contact",
      "Responsive mobile",
    ],
    cta: "Démarrer",
  },
  {
    nom: "Essentiel",
    prix: "100€",
    type: "/ mois",
    tag: "Le plus populaire",
    description: "Pour les artisans avec une enveloppe limitée qui veulent être trouvés localement et rester visibles.",
    inclus: [
      "Tout ce qu'inclut Starter",
      "Création de votre logo",
      "Maintenance & mises à jour",
      "Rapport mensuel Google Search Console",
      "Support réponse sous 24h",
    ],
    cta: "Choisir Essentiel",
  },
  {
    nom: "Pro",
    prix: "1500€",
    type: "une fois",
    tag: null,
    description: "Pour les entreprises qui ont besoin d'une image complète sans mensualités",
    inclus: [
      "Site vitrine personnalisé jusqu'à 10 pages",
      "Création de votre logo",
      "Design de vos cartes de visite",
      "Design de vos flyers dédiés à vos opérations commerciales",
      "Référencement Google local poussé (analyse concurrence)",
      "Google Business Profile configuré",
      "Hébergement 1 an inclus",
      "Formulaire de contact",
      "Responsive mobile",
    ],
    cta: "Choisir Pro",
  },
  
  {
    nom: "Premium",
    prix: "190€",
    type: "/ mois",
    tag: null,
    description: "La suite complète pour dominer votre secteur dans votre zone.",
    inclus: [
      "Tout ce qu'inclut Pro",
      "Publication sur les réseaux sociaux (4 articles/mois)",
      "Optimisation Google Business Profile",
      "Inscription annuaires (PagesJaunes, Houzz…)",
      "Rapport détaillé + appel mensuel",
      "Refonte design annuelle (pour rester dans le coup)",
      "Support prioritaire 7j/7",
    ],
    cta: "Choisir Premium",
  },
];

const REALISATIONS = [
  {
    client: "Darduin Carrelage",
    metier: "Carreleur",
    ville: "Péronne (80)",
    result: "Indexé en 3 semaines · +14 appels/mois",
    tags: ["Vitrine", "Référencement local", "GMB"],
    color: "#C4854A",
  },
  {
    client: "Fidelease App",
    metier: "Technologie Mobile",
    ville: "Amiens (80)",
    result: "Image complète sur mesure, +4 commandes en 1 mois",
    tags: ["Vitrine", "Référencement", "Liens App store"],
    color: "#4A7C8E",
  },
  {
    client: "AMC Leblanc",
    metier: "Entreprise Générale du Bâtiment",
    ville: "Roye (80)",
    result: "Site livré en 8 jours · Note 4,8★ GMB",
    tags: ["Urgence", "Vitrine", "GMB"],
    color: "#6B8C5A",
  },
  // {
  //   client: "Menuiserie Aubert",
  //   metier: "Menuisier",
  //   ville: "Chartres (28)",
  //   result: "+22 demandes de devis en 2 mois",
  //   tags: ["Portfolio", "Référencement", "Blog"],
  //   color: "#8C6B4A",
  // },
];

const PROCESS = [
  {
    num: "01",
    titre: "On se parle",
    desc: "Un échange de 30 minutes — par téléphone, WhatsApp ou email — pour comprendre votre métier, votre zone, vos clients.",
  },
  {
    num: "02",
    titre: "Maquette en 48h",
    desc: "Vous recevez une maquette visuelle de votre futur site. On ajuste ensemble jusqu'à ce que ça vous ressemble.",
  },
  {
    num: "03",
    titre: "Mise en ligne",
    desc: "Le site est développé, testé, et mis en ligne. Google Search Console, sitemap, Référencement local : tout est configuré.",
  },
  {
    num: "04",
    titre: "Suivi mensuel",
    desc: "Chaque mois, vous recevez un rapport avec vos statistiques Google. Vous voyez exactement ce que ça vous apporte.",
  },
];

const AVIS = [
  {
    nom: "Pierre D.",
    metier: "Carreleur",
    ville: "Péronne",
    texte: "Mon site est en ligne depuis 3 semaines et j'ai déjà reçu des appels. J'ai vu la différence. Rapide, simple, et pas de contrat qui dure des années. Je suis content !",
    note: 5,
  },
  {
    nom: "Sébastien L.",
    metier: "Technologie",
    ville: "Amiens",
    texte: "J'avais signé avec une entreprise très présente à Amiens avant. plus de 250€/mois, mon site ne me correspondait pas, j'avais du mal à les joindre et j'ai découvert ensuite que c'était un modèle prédéfinis qu'ils ont juste adapté en quelques heures, je leur ai donné presque 7000€ au total avant de résilier, une honte !. Là c'est le jour et la nuit. Je recommande sans hésiter.",
    note: 5,
  },
  {
    nom: "Denis L.",
    metier: "Bâtiment",
    ville: "Roye",
    texte: "Très professionnel, à l'écoute. Il a compris mon activité tout de suite. Le site est beau, les clients viennent à moi et découvrent mon activité.",
    note: 5,
  },
  // {
  //   nom: "Patrick M.",
  //   metier: "Entreprise Générale du bâtiment",
  //   ville: "Lille",
  //   texte: "Le rapport mensuel que je reçois m'explique clairement ce qui se passe sur mon site. C'est rassurant de savoir que quelqu'un s'en occupe vraiment.",
  //   note: 5,
  // },
];

/* EMAILJS */
const EMAILJS_PUBLIC_KEY   = "DwgrMWni4TPQBi66B";
const EMAILJS_SERVICE_ID   =  "service_k89zav7";
const EMAILJS_TEMPLATE_ID  = "template_ynbp1ri";
/* /emailjs */

function Stars({ n }) {
  return (
    <span className="stars" aria-label={`${n} étoiles sur 5`}>
      {"★".repeat(n)}
    </span>
  );
}

function useInView(threshold = 0.15) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { setInView(true); obs.disconnect(); } },
      { threshold }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, [threshold]);
  return [ref, inView];
}

function Section({ id, children, className = "" }) {
  const [ref, inView] = useInView();
  return (
    <section id={id} ref={ref} className={`section ${className} ${inView ? "visible" : ""}`}>
      {children}
    </section>
  );
}

export default function TerrainWeb() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [formData, setFormData] = useState({ prenom: "", metier: "", email: "", message: "" });
  const [sent, setSent] = useState(false);

  const formRef = useRef();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  function handleSubmit(e) {
    e.preventDefault();

    emailjs
      .sendForm(EMAILJS_SERVICE_ID, EMAILJS_TEMPLATE_ID, formRef.current, EMAILJS_PUBLIC_KEY)
      .then(() => {
        setSent(true);
        formRef.current.reset();
      })
      .catch(() => setSent(false));

    // formData
    setSent(true);
  }

  return (
    <div className="tw-root">
      {/* ── NAV ── */}
      <nav className={`nav ${scrolled ? "nav--scrolled" : ""}`}>
        <a href="#" className="nav-logo" onClick={() => setMenuOpen(false)}>
          <img src={logo} alt="terrain-web-logo" style={{height: '5vh'}} />
          Terrain<span>Web</span>
        </a>
        <button
          className={`nav-burger ${menuOpen ? "open" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menu"
        >
          <span /><span /><span />
        </button>
        <ul className={`nav-links ${menuOpen ? "open" : ""}`}>
          {NAV_LINKS.map((l) => (
            <li key={l.href}>
              <a href={l.href} onClick={() => setMenuOpen(false)}>{l.label}</a>
            </li>
          ))}
          <li>
            <a href="#contact" className="nav-cta" onClick={() => setMenuOpen(false)}>
              Devis gratuit
            </a>
          </li>
        </ul>
      </nav>

      {/* ── HERO ── */}
      <header className="hero">
        <div className="hero-bg-text" aria-hidden="true">LOCAL</div>
        <div className="hero-inner">
          <div className="hero-badge">Sans engagement · Sans frais cachés</div>
          <h1>
            Votre présence professionnelle,<br />
            <em>sur le terrain.</em>
          </h1>
          <p className="hero-sub">
            Artisans, commerçants, TPE — je crée votre image pro, vos supports commerciaux & votre site vitrine sur mesure
            et le positionne sur Google pour que vos clients vous trouvent.
            Pas de contrat. Pas d'agence intermédiaire. Un vrai développeur.
          </p>
          <div className="hero-actions">
            <a href="#contact" className="btn btn-primary">Demander un devis gratuit</a>
            <a href="#formules" className="btn btn-ghost">Voir les formules</a>
          </div>
          <div className="hero-proof">
            <div className="proof-item"><strong>+40</strong><span>clients accompagnés</span></div>
            <div className="proof-sep" aria-hidden="true" />
            <div className="proof-item"><strong>8 jours</strong><span>délai moyen de mise en ligne</span></div>
            <div className="proof-sep" aria-hidden="true" />
            <div className="proof-item"><strong>5★</strong><span>Rapport qualité/prix inégalé</span></div>
          </div>
        </div>
        <div className="hero-scroll-hint" aria-hidden="true">↓</div>
      </header>

      {/* ── STRIP ── */}
      <div className="strip">
        <MetiersTicker />
      </div>

      {/* ── PROMESSE ── */}
      <Section id="promesse" className="section-promesse">
        <div className="container">
          <div className="promesse-grid">
            <div className="promesse-text">
              <span className="eyebrow">Pourquoi Terrain Web ?</span>
              <h2>La concurrence vous engage pour plus de 200€/mois pour un site template.<br />Chez Terrain Web, on fait du sur-mesure.</h2>
              <p>
                Les grandes agences vous font signer des contrats de 12 à 24 mois,
                avec un site généré automatiquement que vous ne pouvez pas modifier.
                Terrain Web, c'est l'opposé : un développeur fullstack dédié,
                du code sur mesure, et la liberté totale.
              </p>
              <ul className="promesse-list">
                <li><span className="check">✓</span> Résiliable à tout moment, sans frais</li>
                <li><span className="check">✓</span> Un design à votre image</li>
                <li><span className="check">✓</span> Un référencement local configuré dès le premier jour</li>
                <li><span className="check">✓</span> Des supports commerciaux physiques (cartes de visite, flyers, flocage)</li>
                <li><span className="check">✓</span> Rapport mensuel transparent</li>
                <li><span className="check">✓</span> Un seul interlocuteur, joignable par WhatsApp</li>
              </ul>
            </div>
            <div className="promesse-visual">
              <div className="compare-card compare-bad">
                <div className="compare-label compare-label--bad">Les autres</div>
                <ul>
                  <li>Contrat 12–24 mois</li>
                  <li>Site template identique à 1000 autres</li>
                  <li>Service client injoignable</li>
                  <li>Référencement en option payante</li>
                  <li>300 € et + par mois</li>
                </ul>
              </div>
              <div className="compare-card compare-good">
                <div className="compare-label compare-label--good">Terrain Web</div>
                <ul>
                  <li>Sans engagement</li>
                  <li>Site sur mesure, unique</li>
                  <li>Réponse sous 24h garantie</li>
                  <li>Un référencement inclus de série</li>
                  <li>À partir de 100 €/mois (puis 50€/mois la deuxième année)</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </Section>

      {/* ── FORMULES ── */}
      <Section id="formules" className="section-formules">
        <div className="container">
          <span className="eyebrow">Tarifs</span>
          <h2>Des formules claires,<br />sans mauvaise surprise.</h2>
          <div className="formules-grid">
            { FORMULES.map((f) => (
              <div key={f.nom} className={`formule-card ${f.tag ? "formule-card--featured" : ""}`}>
                {f.tag && <div className="formule-tag">{f.tag}</div>}
                <div className="formule-header">
                  <h3>{f.nom}</h3>
                  <div className="formule-prix">
                    <strong>{f.prix}</strong>
                    <span className="align-end">{f.type}</span>
                  </div>
                </div>

                  {
                    f.type === "/ mois"
                    && <div className="compare-label compare-label--good" style={{fontSize: "x-small", textAlign: 'center', background: 'MediumAquamarine', color: 'white', display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                      <IoPricetagsOutline style={{fontSize: '30px'}} />
                      <b>prix divisé par deux la deuxième année !</b>
                    </div>
                    
                  }
                <p className="formule-desc">{f.description}</p>
                <ul className="formule-list">
                  {f.inclus.map((item) => (
                    <li key={item}><span className="check">✓</span>{item}</li>
                  ))}
                </ul>
                <a href="#contact" className={`btn ${f.tag ? "btn-primary" : "btn-outline"}`}>
                  {f.cta}
                </a>
              </div>
            ))}
          </div>
          <p className="formules-note">
            Tous les abonnements sont <strong>sans engagement</strong> — résiliables à tout moment,
            sans préavis ni pénalité.
          </p>
        </div>
      </Section>

      {/* ── RÉALISATIONS ── */}
      <Section id="realisations" className="section-realisations">
        <div className="container">
          <span className="eyebrow">Réalisations</span>
          <h2>Des résultats concrets,<br />pour des pros comme vous.</h2>
          <div className="realisations-grid">
            {REALISATIONS.map((r) => (
              <div key={r.client} className="realisation-card" style={{ "--accent": r.color }}>
                <div className="realisation-top">
                  <div className="realisation-avatar" style={{ background: r.color }}>
                    {r.client[0]}
                  </div>
                  <div>
                    <div className="realisation-client">{r.client}</div>
                    <div className="realisation-meta">{r.metier} · {r.ville}</div>
                  </div>
                </div>
                <div className="realisation-result">{r.result}</div>
                <div className="realisation-tags">
                  {r.tags.map((t) => <span key={t} className="realisation-tag">{t}</span>)}
                </div>
              </div>
            ))}
          </div>
        </div>
      </Section>

      {/* ── PROCESS ── */}
      <Section id="process" className="section-process">
        <div className="container">
          <span className="eyebrow">Comment ça marche</span>
          <h2>Simple comme un coup de fil.</h2>
          <div className="process-grid">
            {PROCESS.map((p, i) => (
              <div key={p.num} className="process-step">
                <div className="process-num" aria-hidden="true">{p.num}</div>
                <h3>{p.titre}</h3>
                <p>{p.desc}</p>
                {i < PROCESS.length - 1 && (
                  <div className="process-arrow" aria-hidden="true">→</div>
                )}
              </div>
            ))}
          </div>
          <div className="process-cta-wrap">
            <a href="#contact" className="btn btn-primary">
              Commencer maintenant — c'est gratuit
            </a>
          </div>
        </div>
      </Section>

      {/* ── AVIS ── */}
      <Section id="avis" className="section-avis">
        <div className="container">
          <span className="eyebrow">Avis clients</span>
          <h2>Ce qu'ils disent.</h2>
          <div className="avis-grid">
            {AVIS.map((a) => (
              <div key={a.nom} className="avis-card">
                <Stars n={a.note} />
                <blockquote>"{a.texte}"</blockquote>
                <div className="avis-author">
                  <strong>{a.nom}</strong>
                  <span>{a.metier} · {a.ville}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </Section>

      {/* ── CONTACT ── */}
      <Section id="contact" className="section-contact">
        <div className="container">
          <div className="contact-grid">
            <div className="contact-text">
              <span className="eyebrow">Contact</span>
              <h2>Parlons de votre projet.<br />C'est gratuit.</h2>
              <p>
                Dites-moi qui vous êtes et ce que vous faites.<br/>
                Je vous réponds dans les 24 heures pour vous conseiller.
              </p>
              <div className="contact-infos">
                <a href="tel:+33XXXXXXXXX" className="contact-info-item">
                  <span className="contact-icon">📞</span>
                  <span>07 66 20 43 38</span>
                </a>
                <a href="mailto:bonjour@terrainweb.fr" className="contact-info-item">
                  <span className="contact-icon">✉</span>
                  <span>bonjour@terrainweb.fr</span>
                </a>
                <div className="contact-info-item">
                  <span className="contact-icon">💬</span>
                  <span>WhatsApp disponible</span>
                </div>
              </div>
            </div>
            <div className="contact-form-wrap">
              {sent ? (
                <div className="form-success">
                  <div className="form-success-icon">✓</div>
                  <h3>Message envoyé !</h3>
                  <p>Je vous réponds dans les 24 heures.</p>
                </div>
              ) : (
                <form ref={formRef} className="contact-form" onSubmit={handleSubmit}>
                  <div className="form-row">
                    <label htmlFor="prenom">Votre Nom</label>
                    <input
                      id="prenom"
                      name="prenom"
                      type="text"
                      placeholder="Marie"
                      value={formData.prenom}
                      onChange={(e) => setFormData({ ...formData, prenom: e.target.value })}
                      required
                    />
                  </div>

                  <div className="form-row">
                    <label htmlFor="email">Votre Adresse Email</label>
                    <input
                      id="email"
                      name="email"
                      type="text"
                      placeholder="identifiant@domaine.fr"
                      value={formData.email}
                      onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                      required
                    />
                  </div>

                  <div className="form-row">
                    <label htmlFor="metier">Votre métier</label>
                    <input
                      id="metier"
                      name="metier"
                      type="text"
                      placeholder="Chauffagiste, coiffeur, restaurateur..."
                      value={formData.metier}
                      onChange={(e) => setFormData({ ...formData, metier: e.target.value })}
                      required
                    />
                  </div>
                  
                  <div className="form-row">
                    <label htmlFor="message">Votre projet <span className="optional">(optionnel)</span></label>
                    <textarea
                      id="message"
                      name="message"
                      rows={4}
                      placeholder="En quelques mots : j'ai déjà une clientèle / je pars de zéro / j'interviens sur le secteur de..."
                      value={formData.message}
                      onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                    />
                  </div>
                  <button type="submit" className="btn btn-primary btn-full">
                    Envoyer ma demande →
                  </button>
                  <p className="form-note">Sans engagement. Réponse sous 24h.</p>
                </form>
              )}
            </div>
          </div>
        </div>
      </Section>

      {/* ── FOOTER ── */}
      <footer className="footer">
        <div className="container footer-inner">
          <div className="footer-logo">Terrain<span>Web</span></div>
          <p className="footer-tagline">Votre présence professionnelle, sur le terrain.</p>
          <nav className="footer-nav" aria-label="Liens de pied de page">
            {NAV_LINKS.map((l) => (
              <a key={l.href} href={l.href}>{l.label}</a>
            ))}
          </nav>
          <p className="footer-legal">
            © {new Date().getFullYear()} Terrain Web · Mentions légales · Politique de confidentialité
          </p>
        </div>
      </footer>
    </div>
  );
}
